import { MonthYear } from '@common/types';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Quest/CorporateScenarios/Domain/commands-core';
import Component from 'vue-class-component';

@Component
export default class CorporateScenariosCommands extends VueCqrs 
{
	invokeCreateCorporateScenarioCommandV1(workspaceId: number, strategyId: string, scenarioId: string, name: string, description: string, planningStartDate: MonthYear, planningEndDate: MonthYear,
		denomination: string, applyBenefitsConfidenceFactor: boolean, benefitsConfidenceDate: MonthYear | null, portfolioIds: string[])
	{
		const cmd = new c.CreateCorporateScenarioCommandV1(workspaceId, strategyId, scenarioId, name, description, planningStartDate, planningEndDate, denomination,
			applyBenefitsConfidenceFactor, benefitsConfidenceDate, portfolioIds);

		this.$command(cmd, scenarioId);
	}

	invokeCloneCorporateScenarioCommandV1(workspaceId: number, strategyId: string, sourceId: string, cloneId: string, cloneName: string)
	{
		const cmd = new c.CloneCorporateScenarioCommandV1(workspaceId, strategyId, sourceId, cloneId, cloneName);
		this.$command(cmd, cloneId);
	}

	invokeUpdateCorporateScenarioCommandV1(workspaceId: number, strategyId: string, scenarioId: string, name: string, description: string, planningStartDate: MonthYear, planningEndDate: MonthYear, 
		denomination: string, applyBenefitsConfidenceFactor: boolean, benefitsConfidenceDate: MonthYear | null, portfolioIds: string[])
	{
		const cmd = new c.UpdateCorporateScenarioCommandV1(workspaceId, strategyId, scenarioId, name, description, planningStartDate, planningEndDate, denomination,
			applyBenefitsConfidenceFactor, benefitsConfidenceDate, portfolioIds);

		this.$command(cmd, scenarioId);
	}

	invokeUpdateActivePortfolioScenarioCommandV1(workspaceId: number, strategyId: string, scenarioId: string, portfolioId: string, portfolioScenarioId: string)
	{
		const cmd = new c.UpdateActivePortfolioScenarioCommandV1(workspaceId, strategyId, scenarioId, portfolioId, portfolioScenarioId);
		this.$command(cmd, scenarioId);
	}

	invokeSetPortfolioResourceAllocationCommandV1(workspaceId: number, strategyId: string, scenarioId: string, portfolioId: string, resourceId: string, allocation: number)
	{
		const cmd = new c.SetPortfolioResourceAllocationCommandV1(workspaceId, strategyId, scenarioId, portfolioId, resourceId, allocation);
		this.$command(cmd, resourceId);
	}

	invokeSetPortfolioCapexLimitCommandV1(workspaceId: number, strategyId: string, scenarioId: string, portfolioId: string, limit: number | null)
	{
		const cmd = new c.SetPortfolioCapexLimitCommandV1(workspaceId, strategyId, scenarioId, portfolioId, limit);
		this.$command(cmd, portfolioId);
	}

	invokeSetPortfolioOpexLimitCommandV1(workspaceId: number, strategyId: string, scenarioId: string, portfolioId: string, limit: number | null)
	{
		const cmd = new c.SetPortfolioOpexLimitCommandV1(workspaceId, strategyId, scenarioId, portfolioId, limit);
		this.$command(cmd, portfolioId);
	}

	invokeSetPortfolioOthexLimitCommandV1(workspaceId: number, strategyId: string, scenarioId: string, portfolioId: string, limit: number | null)
	{
		const cmd = new c.SetPortfolioOthexLimitCommandV1(workspaceId, strategyId, scenarioId, portfolioId, limit);
		this.$command(cmd, portfolioId);
	}

	invokeSetPortfolioExpensesLimitCommandV1(workspaceId: number, strategyId: string, scenarioId: string, portfolioId: string, limit: number | null)
	{
		const cmd = new c.SetPortfolioExpensesLimitCommandV1(workspaceId, strategyId, scenarioId, portfolioId, limit);
		this.$command(cmd, portfolioId);
	}

	invokeSetPortfolioOpexExpensesLimitCommandV1(workspaceId: number, strategyId: string, scenarioId: string, portfolioId: string, limit: number | null)
	{
		const cmd = new c.SetPortfolioOpexExpensesLimitCommandV1(workspaceId, strategyId, scenarioId, portfolioId, limit);
		this.$command(cmd, portfolioId);
	}

	invokeSetPortfolioTotalCostLimitCommandV1(workspaceId: number, strategyId: string, scenarioId: string, portfolioId: string, limit: number | null)
	{
		const cmd = new c.SetPortfolioTotalCostLimitCommandV1(workspaceId, strategyId, scenarioId, portfolioId, limit);
		this.$command(cmd, portfolioId);
	}


	invokeDeleteCorporateScenarioCommandV1(workspaceId: number, strategyId: string, scenarioId: string)
	{
		const cmd = new c.DeleteCorporateScenarioCommandV1(workspaceId, strategyId, scenarioId);
		this.$command(cmd, scenarioId);
	}

	invokeOptimizeCorporateScenarioScheduleCommandV1(workspaceId: number, strategyId: string, scenarioId: string, minStartDate: MonthYear, maxStartDate: MonthYear)
	{
		const cmd = new c.OptimizeCorporateScenarioScheduleCommandV1(workspaceId, strategyId, scenarioId, minStartDate, maxStartDate);
		this.$command(cmd, scenarioId);
	}
}
